<template>
  <div class="work">
    <div class="banner">
      <img src="../../assets/images/work/banner.png" alt />
    </div>
    <!-- 线下营销策划与执行 -->
    <div class="plate">
      <div class="title">线下营销策划与执行</div>
      <div class="content">
        <div>
          <img src="../../assets/images/work/plate01_01.png" alt />
          <p>各类型会务/培训拓展活动策划与执行</p>
        </div>
        <div>
          <img src="../../assets/images/work/plate01_02.png" alt />
          <p>店促</p>
        </div>
        <div>
          <img src="../../assets/images/work/plate01_03.png" alt />
          <p>产品市场活动策划与推广</p>
        </div>
        <div>
          <img src="../../assets/images/work/plate01_04.png" alt />
          <p>品牌应用推广</p>
        </div>
      </div>
      <!-- 查看更多 -->
      <div class="mores">
        <span class="more" @click="open()">
          查看更多
          <img :class="arrow == false ? '':'arrow'" src="../../assets/images/work/arrow.png" alt />
        </span>
      </div>
      <div class="describe">
        <img :class="arrow == false ? 'close':'open'" src="../../assets/images/work/plate01_05.png" alt />
        <img :class="arrow == false ? 'close':'open'" src="../../assets/images/work/plate01_06.png" alt />
        <img :class="arrow == false ? 'close':'open'" src="../../assets/images/work/plate01_07.png" alt />
        <img :class="arrow == false ? 'close':'open'" src="../../assets/images/work/plate01_08.png" alt />
      </div>
    </div>
    <!-- 移动互联网线上营销策划执行 -->
    <div class="plate">
      <div class="title">移动互联网线上营销策划执行</div>
      <div>
        <!-- 第一层 -->
        <div class="onLine_01">
          <div>
            <img src="../../assets/images/work/plate02_01.png" alt />
            <p>微信微博公众号运营</p>
          </div>
          <div>
            <img src="../../assets/images/work/plate02_02.png" alt />
            <p>内容制造与传播</p>
          </div>
          <div>
            <img src="../../assets/images/work/plate02_03.png" alt />
            <p>KOL传播推广</p>
          </div>
          <div>
            <img src="../../assets/images/work/plate02_04.png" alt />
            <p>粉丝运营</p>
          </div>
        </div>
        <!-- 第二层 -->
        <div class="onLine_02">
          <div>
            <img src="../../assets/images/work/plate02_05.png" alt />
            <p>线上品牌推广</p>
          </div>
          <div>
            <img src="../../assets/images/work/plate02_06.png" alt />
            <p>APP与H5网页开发</p>
          </div>
          <div>
            <img src="../../assets/images/work/plate02_07.png" alt />
            <p>线上活动策划</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      arrow: false
    }
  },
  created() {},
  methods: {
    open() {
      this.arrow = !this.arrow
    }
  }
}
</script>

<style scoped>
.work {
  width: 100%;
}
.work .banner {
  width: 100%;
  height: 240px;
  position: relative;
  overflow: hidden;
}
.work .banner img {
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  width: auto;
  height: 100%;
}
.work .plate {
  width: 100%;
  max-width: 1100px;
  margin: 20px auto;
  background-color: #fff;
  padding-bottom: 10px;
}
.work .plate .title {
  width: 100%;
  height: 40px;
  background-color: rgb(235, 89, 25);
  line-height: 40px;
  text-align: center;
  color: #fff;
  font-size: 20px;
  font-weight: 400;
}
.work .plate .content {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}
.work .plate .content div {
  height: 228px;
  width: 266px;
  border: 1px solid rgb(220, 220, 220);
  border-radius: 4px;
  box-sizing: border-box;
  margin-bottom: 20px;
}
.work .plate .content div img {
  width: 100%;
  height: 144px;
}
.work .plate .content div p {
  padding: 20px 10px;
  width: 80%;
  height: 60px;
  box-sizing: border-box;
  color: rgb(235, 89, 25);
}
.work .plate .mores {
  width: 100%;
  position: relative;
  height: 40px;
}
.work .plate .more {
  position: absolute;
  right: 4px;
  display: block;
  width: 120px;
  height: 40px;
  color: #fff;
  text-align: center;
  line-height: 40px;
  background-color: rgb(235, 89, 25);
}
.work .plate .mores .arrow {
  transform: rotate(180deg);
}
.work .plate .describe {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  margin-top: 10px;
  overflow: hidden;
}
.work .plate .describe .open {
  animation: height0_511 1s forwards;
}
.work .plate .describe .close {
animation: height511_0 1s forwards;
}
.work .plate .onLine_01 {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}
.work .plate .onLine_01 div {
  height: 200px;
  width: 266px;
  border: 1px solid rgb(220, 220, 220);
  border-radius: 4px;
  box-sizing: border-box;
  margin-bottom: 20px;
}
.work .plate .onLine_01 div img {
  width: 100%;
}
.work .plate .onLine_01 div p {
  padding: 10px 10px;
  width: 80%;
  height: 60px;
  box-sizing: border-box;
  color: rgb(235, 89, 25);
}
.work .plate .onLine_02 {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}
.work .plate .onLine_02 div {
  height: 200px;
  width: 350px;
  border: 1px solid rgb(220, 220, 220);
  border-radius: 4px;
  box-sizing: border-box;
  margin-bottom: 20px;
}
.work .plate .onLine_02 div img {
  width: 100%;
}
.work .plate .onLine_02 div p {
  padding: 10px 10px;
  width: 80%;
  height: 60px;
  box-sizing: border-box;
  color: rgb(235, 89, 25);
}
</style>
